/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsTransferSerialNumber
 */
export interface ControlcenterMelcoModelsTransferSerialNumber {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsTransferSerialNumber
     */
    existing_user_reference_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsTransferSerialNumber
     */
    new_user_reference_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsTransferSerialNumber
     */
    serial_number?: string | null;
}

export function ControlcenterMelcoModelsTransferSerialNumberFromJSON(json: any): ControlcenterMelcoModelsTransferSerialNumber {
    return ControlcenterMelcoModelsTransferSerialNumberFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsTransferSerialNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsTransferSerialNumber {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'existing_user_reference_id': !exists(json, 'existing_user_reference_id') ? undefined : json['existing_user_reference_id'],
        'new_user_reference_id': !exists(json, 'new_user_reference_id') ? undefined : json['new_user_reference_id'],
        'serial_number': !exists(json, 'serial_number') ? undefined : json['serial_number'],
    };
}

export function ControlcenterMelcoModelsTransferSerialNumberToJSON(value?: ControlcenterMelcoModelsTransferSerialNumber | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'existing_user_reference_id': value.existing_user_reference_id,
        'new_user_reference_id': value.new_user_reference_id,
        'serial_number': value.serial_number,
    };
}


